import { render, staticRenderFns } from "./StaffLiveView.vue?vue&type=template&id=184298c6&scoped=true&"
import script from "./StaffLiveView.vue?vue&type=script&lang=js&"
export * from "./StaffLiveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184298c6",
  null
  
)

export default component.exports